import { managerMappingKeys } from './mappings';

export default rawData => {
    let obj = {};
    
    Object.keys(managerMappingKeys).forEach(key => {
        obj[managerMappingKeys[key]] = rawData[key];
    });
    return obj;
};